/* TypeScript file generated from Ideas_Page.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as Ideas_PageJS from './Ideas_Page.re.mjs';

export type props = {};

export const make: React.ComponentType<{}> = Ideas_PageJS.make as any;

export const $$default: React.ComponentType<{}> = Ideas_PageJS.default as any;

export default $$default;
